<template>
    <div class="modal-backdrop" @click.self="handleClose">
        <div class="modal-card">
            <button class="modal-close" type="button" @click="handleClose">&times;</button>

            <div class="modal-image" v-if="benefitImage">
                <img :src="benefitImage" :alt="title">
            </div>

            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">{{ title }}</h2>
                    <p class="modal-location">{{ location }}</p>
                </div>

                <div class="benefit-availability">
                    <div class="availability-badge">
                        <span>Ready to Enjoy</span>
                    </div>
                    <p class="availability-text">
                        This exclusive benefit is now available for your tier. You can start enjoying this privilege right away at participating locations.
                    </p>
                </div>

                <p class="modal-description">{{ description }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { benefitImageMixin } from '@/composables/useBenefitImage';

export default {
    name: 'BenefitDetailModal',
    props: {
        benefit: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    emits: ['close'],
    mixins: [benefitImageMixin],
    mounted() {
        document.body.style.overflow = 'hidden';
    },
    beforeUnmount() {
        document.body.style.overflow = '';
    },
    computed: {
        title() {
            return this.benefit?.name || 'Member Benefit';
        },
        location() {
            return this.benefit?.merchant?.name
                || this.benefit?.branch?.name
                || this.benefit?.corporate?.name
                || '—';
        },
        description() {
            return this.benefit?.desc
                || this.benefit?.description
                || 'Benefit description is currently unavailable.';
        },
        benefitImage() {
            return this.benefitImageUrlFromTheme
                || '/img/member-img/offer-example.svg';
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(17, 24, 39, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    z-index: 1000;
}

.modal-card {
    position: relative;
    width: min(480px, 100%);
    background: #ffffff;
    border-radius: 16px;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
}

.modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #E1E4EA;
    background: rgba(255, 255, 255, 0.92);
    color: #111827;
    font-size: 18px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.modal-close:hover {
    background: #F3F4F6;
}

.modal-image {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #f3f4f6;
    overflow: hidden;
}

.modal-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.modal-header {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 24px 24px 12px;
    align-items: start;
}

.modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1B1E28;
    line-height: 1.4;
}

.modal-location {
    margin: 0;
    font-size: 14px;
    color: #717784;
    line-height: 1.4;
}

.benefit-availability {
    background: #F8FAFC;
    border-radius: 12px;
    padding: 16px 20px;
    margin: 0 24px;
    border: 1px solid #E2E8F0;
}

.availability-badge {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.availability-badge span {
    font-size: 14px;
    font-weight: 600;
    color: #1E293B;
}

.availability-text {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #475569;
}

.modal-description {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    color: #374151;
    padding: 16px 24px 24px;
    white-space: pre-line;
}

.modal-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 8px;
}
</style>
